import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ErrorMessages } from '@smarsh-cyber/shared/constants';
import { ReqStatus } from '@smarsh-cyber/shared/models';
import {
  LoginRES,
  ResetPasswordRES,
  VerifyOtpRES,
  VerifyUserRES
} from '../models/api_models';
import {
  LoginModel,
  ResetPasswordModel,
  VerifyOtpModel,
  VerifyUserModel
} from '../models/ui_models';

export const translateForgetPasswordRes = (
  apiResponse: ResetPasswordRES
): ResetPasswordModel => {
  return {
    data: apiResponse.data,
    errors: [],
    pageState: null,
    reqState: {
      httpCode: null,
      modalStatus: null,
      message: apiResponse.message,
      cyberCode: apiResponse.cyberCode,
      reqStatus: ReqStatus.SUCCESS
    }
  };
};

export const translateLoginRes = (apiResponse: LoginRES): LoginModel => {
  return {
    data: {
      accessToken: apiResponse.data.access_token,
      refreshToken: apiResponse.data.refresh_token
    },
    errors: [],
    pageState: null,
    reqState: {
      httpCode: null,
      modalStatus: null,
      message: '',
      cyberCode: 0,
      reqStatus: ReqStatus.SUCCESS
    }
  };
};

export const translateVerifyEmailRes = (
  apiResponse: VerifyUserRES
): VerifyUserModel => {
  return {
    data: apiResponse.data,
    errors: [],
    pageState: null,
    reqState: {
      httpCode: null,
      modalStatus: null,
      message: apiResponse.message,
      cyberCode: apiResponse.cyberCode,
      reqStatus: ReqStatus.SUCCESS
    }
  };
};

export const translateVerifyOtpRes = (
  apiResponse: VerifyOtpRES
): VerifyOtpModel => {
  return {
    data: apiResponse.data,
    errors: [],
    pageState: null,
    reqState: {
      httpCode: null,
      modalStatus: null,
      message: apiResponse.message,
      cyberCode: apiResponse.cyberCode,
      reqStatus: ReqStatus.SUCCESS
    }
  };
};

export const translateErrorRes = (
  apiResponse: HttpErrorResponse
): ResetPasswordModel => {
  // const httpError = apiResponse instanceof HttpErrorResponse ? true : false;
  let message = '';
  const status = apiResponse?.status;
  switch (status) {
    case HttpStatusCode.Unauthorized:
    case HttpStatusCode.BadRequest:
      message = ErrorMessages.LOGIN_UNATHORISED;
      break;
    case HttpStatusCode.Forbidden:
      message = apiResponse?.error?.message;
      break;
    default:
      message = ErrorMessages.GENERIC_ERROR;
  }

  return {
    data: null,
    errors: [
      {
        message: apiResponse.message,
        status: apiResponse.status
          ? HttpStatusCode.Ok
          : HttpStatusCode.InternalServerError
      }
    ],
    pageState: null,
    reqState: {
      httpCode: apiResponse.status,
      modalStatus: null,
      message,
      cyberCode: 0, //TODO
      reqStatus: ReqStatus.ERROR
    }
  };
};

export const translateVerifyOTPErrorRes = (
  apiResponse: HttpErrorResponse
): ResetPasswordModel => {
  let message = '';
  const status = apiResponse?.status;
  switch (status) {
    case HttpStatusCode.Unauthorized:
    case HttpStatusCode.BadRequest:
      message = ErrorMessages.INVALID_OTP;
      break;
    case HttpStatusCode.Forbidden:
      message = apiResponse?.error?.message;
      break;
    default:
      message = ErrorMessages.GENERIC_ERROR;
  }

  return {
    data: null,
    errors: [
      {
        message: apiResponse.message,
        status: apiResponse.status
          ? HttpStatusCode.Ok
          : HttpStatusCode.InternalServerError
      }
    ],
    pageState: null,
    reqState: {
      httpCode: apiResponse.status,
      modalStatus: null,
      message,
      cyberCode: 0, //TODO
      reqStatus: ReqStatus.ERROR
    }
  };
};

export const translateVerifyUserErrorRes = (
  apiResponse: HttpErrorResponse
): ResetPasswordModel => {
  let message = '';
  const status = apiResponse?.status;
  switch (status) {
    case HttpStatusCode.Unauthorized:
    case HttpStatusCode.BadRequest:
      message = ErrorMessages.INVALID_USER;
      break;
    case HttpStatusCode.Forbidden:
      message = apiResponse?.error?.message;
      break;
    default:
      message = ErrorMessages.GENERIC_ERROR;
  }

  return {
    data: null,
    errors: [
      {
        message: apiResponse.message,
        status: apiResponse.status
          ? HttpStatusCode.Ok
          : HttpStatusCode.InternalServerError
      }
    ],
    pageState: null,
    reqState: {
      httpCode: apiResponse.status,
      modalStatus: null,
      message,
      cyberCode: 0, //TODO
      reqStatus: ReqStatus.ERROR
    }
  };
};

export const translateResetPasswordErrorRes = (
  apiResponse: HttpErrorResponse
): ResetPasswordModel => {
  let message = '';
  const status = apiResponse?.status;
  switch (status) {
    case HttpStatusCode.BadRequest:
      message = ErrorMessages.RESET_PWD_ERROR;
      break;
    default:
      message = ErrorMessages.GENERIC_ERROR;
  }

  return {
    data: null,
    errors: [
      {
        message: apiResponse.message,
        status: apiResponse.status
          ? HttpStatusCode.Ok
          : HttpStatusCode.InternalServerError
      }
    ],
    pageState: null,
    reqState: {
      httpCode: apiResponse.status,
      modalStatus: null,
      message,
      cyberCode: 0, //TODO
      reqStatus: ReqStatus.ERROR
    }
  };
};
